export default __webpack_public_path__ + "static/media/(90).e3ba9cc8.jpg";